import { ValueStore } from '@proscom/prostore';

export class TargetStore extends ValueStore<string | null> {
  constructor() {
    super(null);
  }
}
